export default class ContactLogin {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', () => {
				const forms = Array.from(document.getElementsByTagName('form'));
				el.parentElement?.classList.add('cursor--wait');
				forms.forEach((form) => {
					form?.classList.add('pointer--none');
					form?.classList.remove('cursor--pointer');
				});
				el.submit();
			});
		});
	}
}
